import React from "react";
import { connect } from "react-redux";
import { NavLink, Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';

import MyProfile from "./MyProfile";
import History from "./History";
import Portfolio from "./Portfolio";
import AlienProfile from "./AlienProfile";
import AlienEquipment from "./AlienEquipment";
import Equipment from "./Equipment";
import LeftNavContent from '../Commons/LeftNavContent';

import { whereBallsMove, getHeader, getToken } from "../../helper";
import { deleteEquipment } from '../../actions/equipmentActions';

class Profile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            alienProfile: true,
            alienFetching: false,
            pageNotFound: false,
            otherProfileData: [],

            deleteEquipment: {
                show: false,
                type: 'warning',
                elem: null,
            }
        }
    }

    componentWillMount() {
        const { session, match } = this.props;
        this.checkUser(session, match.params.id);
    }

    componentDidMount() {
        document.title = 'Fixfact - Профиль';
        whereBallsMove(2);
    }

    componentWillReceiveProps(nextProps) {
        const { session, match} = nextProps;

        if(this.props.match.params.id !== match.params.id){
            this.checkUser(session, match.params.id);
        }
    }

    checkUser(session, id) {
        if(session.isLoggedIn && (parseInt(session.currentUser.id) === parseInt(id) || id === undefined)){
            this.setState({alienProfile: false});
        }
        else{
            this.setState({
                alienFetching: true,
                alienProfile: true
            }, () => this.getAlienProfile(id));
        }
    }    

    getAlienProfile(id) {
        axios.get(`${window.siteUrl}/api/v1/user/${id}/`)
        .then((response) => {

            this.setState({
                alienFetching: false,
                pageNotFound: false,
                otherProfileData: Object.assign([], response.data)
            })
        })
        .catch((error) => {
            this.setState({
                alienFetching: false,
                pageNotFound: true
            })
        });
    }

    toggleDeleteModal(elem) {
        if(!elem || !elem.id) return false;

        this.setState({
            deleteEquipment:{
                ...this.state.deleteEquipment,
                show: true,
                elem,
            }
        })
    }

    deleteConfirm() {
        const {elem} = this.state.deleteEquipment;
        if(!elem) return false;
        
        this.props.deleteEquipment(
            elem.id,
            {is_deleted: true},
            () => {
                this.setState({
                    deleteEquipment:{
                        ...this.state.deleteEquipment,
                        type: 'success',
                        text: `Оборудование ${elem.title} удалено.`
                    }
                })
            }
        )
    }

    deleteCancel() {
        this.setState({
            deleteEquipment:{
                ...this.state.deleteEquipment,
                show: false,
                type: 'warning',
                elem: null,
            }
        });
    }

    render() {

        const { session, match,} = this.props;
        const { isLoggedIn, currentUser } = session;
        const { otherProfileData, alienFetching, pageNotFound, alienProfile } = this.state;
        
        if(alienFetching) return '';

        if(pageNotFound){
            return <Redirect to='/404' />;
        }

        const isMy = (isLoggedIn && !alienProfile) ? true : false;
        const userData = (!alienProfile) ? {...currentUser} : {...otherProfileData};
        let title = 'Вы уверены, что хотите удалить оборудование?';
        if(this.state.deleteEquipment.type === 'success') title = this.state.deleteEquipment.text || 'Оборудование удалено';
        if(this.state.deleteEquipment.type === 'error') title = 'Ошибка';

        return (
            <div className="vertical-scrolling page secondSection sectionProfile">
                <div className="container content">

                    <SweetAlert
                        type={this.state.deleteEquipment.type}
                        show={this.state.deleteEquipment.show}
                        confirmBtnCssClass="alert-btn-confirm"
                        cancelBtnCssClass="alert-btn-cancel"
                        showCancel
                        showConfirm={this.state.deleteEquipment.type === 'success' ? false : true}
                        confirmBtnText={"Продолжить"}
                        cancelBtnText={this.state.deleteEquipment.type === 'success' ? "Закрыть" : "Отменить"}
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title={title}
                        onConfirm={() => this.deleteConfirm()}
                        onCancel={() => this.deleteCancel()}
                    >
                    </SweetAlert>
                    
                    <LeftNavContent>
                        <h2 className="left-content__title">Профиль</h2>
                        <ul className="menu-content-nav">                                
                            {
                                isLoggedIn && !alienProfile
                                ? <NavLink exact to="/profile">Мой профиль</NavLink>
                                : <NavLink exact to={`/profile/${userData.id}`}>{userData.first_name}</NavLink>
                            }
                            <NavLink to={`/profile/${userData.id}/history`}>Заказы</NavLink>
                            <NavLink to={`/profile/${userData.id}/portfolio`}>Портфолио</NavLink>
                            <NavLink to={`/profile/${userData.id}/equipment`}>Оборудование</NavLink>
                        </ul>
                    </LeftNavContent>
              
                    <div className="right-content native-scroll right-content-width">
                        <div className="screen-outer-block-wrap native-scroll menu-content">
                            <Switch>
                                <Route
                                    path={`/profile/${userData.id}/portfolio/:id?`}
                                    render={(props) => (<Portfolio {...props} userData={userData} alien={!isMy} />)}
                                />

                                <Route
                                    path={`/profile/${userData.id}/history/:id?`}
                                    render={(props) => (<History {...props} userData={userData} alien={!isMy} />)}
                                />

                                {
                                    isLoggedIn && !alienProfile
                                    ? <Route
                                        path={`/profile/${userData.id}/equipment/:id?`}
                                        render={(props) => (
                                            <Equipment
                                                {...props}
                                                toggleDeleteModal={(equipment) => this.toggleDeleteModal(equipment)}
                                                />
                                        )} />
                                    : <Route path={`/profile/:id?/equipment`}
                                            render={(props) => (<AlienEquipment {...props} id={userData.id}/>)} />
                                }
                                {
                                    isLoggedIn && !alienProfile
                                    ?   <Route
                                            path="/profile"
                                            render={(props) => (<MyProfile {...props} pageData={userData} />
                                        )} />
                                    :   <Route
                                            path="/profile/:id?"
                                            render={(props) => (<MyProfile {...props} pageData={userData} alien={true}/>
                                        )} />
                                }
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
      ...state
    };
  };
  
export default connect(
    mapStateToProps,
    {
        deleteEquipment,
    }
)(Profile);


// WEBPACK FOOTER //
// ./src/components/Profile/index.js